import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCommonModule, MatPseudoCheckboxModule, MatRippleModule } from '@angular/material/core';
import { MatOptionComponent } from './option.component';

@NgModule({
  imports: [MatRippleModule, CommonModule, MatCommonModule, MatPseudoCheckboxModule],
  exports: [MatOptionComponent],
  declarations: [MatOptionComponent],
})
export class OptionModule {}
